// sections/DetailTimelineSection.tsx

import { useReceivableDetail } from "../../hooks/useReceivableDetail";

const DetailTimelineSection = () => {
  const { detail } = useReceivableDetail();

  if (!detail) return null;

  const timeline = detail.timeline || [];

  return (
    <section
      className="
        rounded-xl
        border border-stroke
        bg-white
        p-6
        shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <h4 className="mb-5 text-base font-semibold text-black dark:text-white">
        Timeline Financiero
      </h4>

      {timeline.length === 0 ? (
        <div
          className="
            rounded-lg
            border border-dashed border-gray
            bg-gray-2
            p-5
            dark:border-strokedark
            dark:bg-boxdark-2
          "
        >
          <p className="text-sm text-body dark:text-bodydark">
            No hay eventos registrados para esta cuenta por cobrar.
          </p>
        </div>
      ) : (
        <div className="space-y-5">
          {timeline.map((item: any, index: number) => (
            <div
              key={`${item.type}-${index}`}
              className="relative flex gap-4"
            >
              {/* Línea vertical */}
              <div className="flex flex-col items-center">
                <div
                  className="
                    h-3 w-3
                    rounded-full
                    bg-primary
                  "
                />

                {index !== timeline.length - 1 && (
                  <div
                    className="
                      mt-1
                      h-full
                      w-[2px]
                      bg-stroke
                      dark:bg-strokedark
                    "
                  />
                )}
              </div>

              {/* Contenido */}
              <div
                className="
                  flex-1
                  rounded-lg
                  border border-gray
                  bg-gray-2
                  p-4
                  dark:border-strokedark
                  dark:bg-boxdark-2
                "
              >
                <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                  <h5 className="font-semibold text-black dark:text-white">
                    {item.title}
                  </h5>

                  <span className="text-sm text-body dark:text-bodydark">
                    {item.eventDate || "-"}
                  </span>
                </div>

                <p className="mt-2 text-sm leading-relaxed text-body dark:text-bodydark">
                  {item.description || "Sin descripción"}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default DetailTimelineSection;